var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#DBEBFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 18.25H19.5C18.8096 18.25 18.25 18.8096 18.25 19.5V44.5C18.25 45.1904 18.8096 45.75 19.5 45.75H44.5C45.1904 45.75 45.75 45.1904 45.75 44.5V19.5C45.75 18.8096 45.1904 18.25 44.5 18.25Z",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 15.75V20.75",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 15.75V20.75",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36.7719L36.6359 39.5L35.375 34.4078L39.5 31.0016L34.0859 30.5844L32 25.75L29.9141 30.5844L24.5 31.0016L28.625 34.4078L27.3641 39.5L32 36.7719Z",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10);
export default __webpack_public_path__ + "static/media/icon10.dc0eb6abdff816b494f2a12ce33165c5.svg";
export { ForwardRef as ReactComponent };